<template>
    <!-- 课程管理 -->
    <div class="course">
        <p class="font-medium font-size16 title">操作日志记录</p>
        <search-form :search-form.sync="searchForm" @search="handleSearch"/>
        <el-table class="clearfix" size="mini"
                  border highlight-current-row
                  stripe :data="tableList">
            <el-table-column label="操作人员" prop="UserName" align="center"/>
            <el-table-column label="文件名称" prop="Name" align="center"/>
            <el-table-column label="类型" prop="Type"
                             :formatter="(row, column, val) => OPTIONS_TYPE[val]"
                             align="center" show-overflow-tooltip/>
            <el-table-column label="操作数据" prop="Remark" align="center" min-width="120"/>
            <el-table-column label="操作" prop="actions" min-width="70" align="center">
                <template v-slot="{ row }">
                    <el-row type="flex" align="middle" justify="center">
                        <el-popconfirm
                            @confirm="handleDel(row)"
                            title="确定删除吗？">
                            <el-button type="danger" slot="reference" plain size="mini">删除</el-button>
                        </el-popconfirm>
                        <el-button type="primary"
                                   size="mini"
                                   plain
                                   @click.stop="handleDownload(row)"
                                   style="margin-left: 10px">下载
                        </el-button>
                    </el-row>
                </template>
            </el-table-column>
        </el-table>
        <pagination :p-size.sync="pagination.pageSize"
                    :page-no.sync="pagination.page"
                    @change="getFileLogList"
                    :total="pagination.total"/>
    </div>
</template>

<script>
import { getIntiSearchForm, OPTIONS_TYPE } from "./config"
import { getFileLogList, delFileLog } from "@/api/manage"
import SearchForm from "./cpns/SearchForm"
import Pagination from "@/components/Pagination";
import { downloadUrl } from "download.js";

export default {
    name: "log",
    components: {
        Pagination,
        SearchForm,
    },
    data() {
        return {
            searchForm: getIntiSearchForm(),
            pagination: {
                page: 1,
                pageSize: 10,
                total: 10
            },
            courseState: 0,
            tableList: [],
            OPTIONS_TYPE
        }
    },
    created() {
        this.getFileLogList()
    },
    methods: {
        // 获取课程列表
        getFileLogList() {
            const {
                page,
                pageSize
            } = this.pagination
            getFileLogList({
                pageIndex: page,
                pageSize,
                ...this.searchForm
            }).then(res => {
                this.tableList = res.data
                this.pagination.total = res.count
            }).catch(e => {
                this.pagination.page = 1
                this.tableList = []
                this.$message.error(e.message || "获取列表失败")
            })
        },
        // 处理搜索
        handleSearch() {
            this.pagination.page = 1
            this.getFileLogList()
        },
        handleDownload(item) {
            downloadUrl(item.Name, item.url)
        },
        // 处理删除
        handleDel (item) {
            delFileLog(item.Id).then(res => {
                this.$message.success("删除成功")
                this.getFileLogList()
            })
        }
    },
}
</script>

<style scoped lang="less">
.title {
    margin-bottom: 30px;
}

.course {
    padding: 20px 40px;
    font-size: 16px;
}
</style>
